import React from 'react';
import {
  DecisionTreeFieldsFragment, DecisionTreeNodeFieldsFragment,
  DecisionTreeRunHistoryItemFieldsFragment,
} from '../../../../generated/core-api/graphql-react-query';

export interface DecisionTreeInfoContextProps {
  decisionTree: DecisionTreeFieldsFragment | null;
  nodeHistory: (DecisionTreeRunHistoryItemFieldsFragment & { node: DecisionTreeNodeFieldsFragment })[];
}

export const DecisionTreeInfoContext = React.createContext<DecisionTreeInfoContextProps | null>(null);

export default function useDecisionTreeInfoContext() {
  const context = React.useContext(DecisionTreeInfoContext);
  if (!context) {
    throw new Error('useDecisionTreeInfoContext must be used within a DecisionTreeInfoContextProvider');
  }
  return context;
}
